import React from 'react';
import HeaderV2 from './components/HeaderV2';
import MainBodyV2 from './components/MainBodyV2';
import MobilePageContainer from './MobilePageContainer';

const MobileTestBlockerV2 = () => {
    return (
        <MobilePageContainer 
            HeaderComponent={HeaderV2} 
            MainBodyComponent={MainBodyV2} 
            event_name="MOBILE_SCREEN_BLOCKER_V2"
            api_data={{
                endpoint: "user/send-login-link",
                body: { redirectPath: window.location.pathname, version: 'v2' }
            }}
        />
    );
};

export default MobileTestBlockerV2;
